import React, { ReactNode } from 'react';
import Heading from 'elements/typography/heading';
import {
  CallToActionSecondaryContainer,
  CTAChildrenContainer
} from 'src/molecules/callToAction/CallToAction.secondary.styles';

interface CallToActionSecondaryProps {
  title: string;
  children: ReactNode;
}

const CallToActionSecondary = ({ title, children }: CallToActionSecondaryProps): JSX.Element => {
  return (
    <CallToActionSecondaryContainer>
      <Heading text={title} size="40px" sizeSubLg="24px" sizeLg="40px" align="center"/>

      <CTAChildrenContainer>
        {children}
      </CTAChildrenContainer>
    </CallToActionSecondaryContainer>
  );
};

export default CallToActionSecondary;
